<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
      </v-toolbar>
      <v-card-text style="padding: 20px">
        <v-container>
          <v-form ref="form" v-model="valid" lazy-validation>
            <div class="flexd">
              <v-avatar size="150" tile>
                <img
                  :src="
                    data.driver_photo
                      ? $store.state.urlImages + data.driver_photo
                      : require('@/assets/no-image.jpg')
                  "
                  :alt="data.driver_name"
                  @click="$refs.fileInput.click()"
                />
                <input
                  type="file"
                  label="Foto:"
                  accept="image/jpeg, image/png"
                  @change="uploadImage"
                  ref="fileInput"
                  style="display: none"
                />
              </v-avatar>
              <p>Clique na imagem para adicionar foto</p>
            </div>
            <v-row>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Código:" v-model="data.driver_cod" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Nome:"
                  :rules="fieldRules"
                  v-model="data.driver_name"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-autocomplete
                  label="Prefeitura:"
                  :rules="fieldRules"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  v-model="data.prefecture_id"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Cpf:"
                  v-mask-cpf
                  v-model="data.driver_cpf"
                  :error="data.driver_cpf !== '' && !validCpf(data.driver_cpf)"
                  :error-messages="
                    data.driver_cpf !== '' && !validCpf(data.driver_cpf)
                      ? 'CPF INVALIDO'
                      : ''
                  "
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Data Nascimento:"
                  v-mask-date.br
                  v-model="data.driver_birth"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-select
                  label="Sexo:"
                  :items="['Masculino', 'Feminino', 'Outros']"
                  v-model="data.driver_genre"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  label="Nivel de Formação:"
                  :items="[
                    'Fundamental Incompleto',
                    'Fundamental Completo',
                    'Ensino Médio Incompleto',
                    'Ensino Médio Completo',
                    'Ensino Superior Incompleto',
                    'Ensino Superior Completo',
                    'Mestrado',
                    'Doutorado',
                    'Pós-Doutorado',
                  ]"
                  v-model="data.driver_education_level"
                />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-select
                  label="Estado Civil:"
                  :items="['Casado', 'Solteiro', 'Viúvo', 'União Estável']"
                  v-model="data.driver_marital_status"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="E-mail:" v-model="data.driver_mail" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Celular:"
                  v-mask-phone.br
                  v-model="data.driver_cel"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field
                  label="Telefone:"
                  v-mask-phone.br
                  v-model="data.driver_tel"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Cep:"
                  v-mask-cep
                  v-model="data.driver_postal_code"
                  :loading="loader"
                  @blur="getCep(data.driver_postal_code)"
                />
              </v-col>
              <v-col cols="12" sm="12" md="8">
                <v-text-field
                  label="Logradouro:"
                  v-model="data.driver_street"
                />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field label="Número:" v-model="data.driver_number" />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field
                  label="Complemento:"
                  v-model="data.driver_complement"
                />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Bairro:" v-model="data.driver_district" />
              </v-col>
              <v-col cols="12" sm="12" md="4">
                <v-text-field label="Cidade:" v-model="data.driver_city" />
              </v-col>
              <v-col cols="12" sm="12" md="2">
                <v-text-field label="Estado:" v-model="data.driver_state" />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Login:" v-model="data.driver_login" />
              </v-col>
              <v-col cols="12" sm="12" md="6">
                <v-text-field label="Senha:" v-model="data.driver_password" />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-footer style="padding: 10px">
        <v-spacer />
        <v-btn
          :disabled="!valid && loader"
          depressed
          large
          color="primary"
          class="mr-4"
          :loading="loader"
          @click="validate"
          >Confirmar</v-btn
        >
      </v-footer>
    </v-card>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  props: ["id"],
  data: () => ({
    valid: false,
    loader: false,
    prefectures: [],
    fieldRules: [(v) => !!v || "Este campo é requerido"],
    snack: {
      show: false,
      message: "",
      color: "success",
    },
    data: {
      driver_cod: "",
      driver_id: null,
      driver_name: "",
      driver_photo: "",
      driver_cpf: "",
      driver_birth: "",
      driver_genre: "",
      driver_education_level: "",
      driver_marital_status: "",
      driver_mail: "",
      driver_cel: "",
      driver_tel: "",
      driver_postal_code: "",
      driver_street: "",
      driver_number: "",
      driver_complement: "",
      driver_district: "",
      driver_city: "",
      driver_state: "",
      driver_login: "",
      driver_password: "",
      prefecture_id: null,
    },
  }),
  created() {
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    if (this.id) {
      this.$store.dispatch("setLoader", true);
      this.$http.get(`drivers/${this.id}`).then((r) => {
        this.data = r.data[0];
        delete this.data.created_at;
        this.$store.dispatch("setLoader", false);
      });
    }
  },
  methods: {
    validCpf(cpf) {
      cpf = cpf.replace(/\D/g, "");
      if (cpf.toString().length != 11 || /^(\d)\1{10}$/.test(cpf)) return false;
      var result = true;
      [9, 10].forEach(function (j) {
        var soma = 0,
          r;
        cpf
          .split(/(?=)/)
          .splice(0, j)
          .forEach(function (e, i) {
            soma += parseInt(e) * (j + 2 - (i + 1));
          });
        r = soma % 11;
        r = r < 2 ? 0 : 11 - r;
        if (r != cpf.substring(j, j + 1)) result = false;
      });
      return result;
    },
    validate() {
      this.snack.show = true;
      this.loader = true;
      if (this.$refs.form.validate()) {
        this.createOrUpdate();
      } else {
        this.snack.show = true;
        this.snack.color = "warning";
        this.snack.message =
          "Atencão um ou mais campos precisam ser preenchidos!";
        this.loader = false;
      }
    },
    createOrUpdate() {
      this.loader = true;
      if (this.id) {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .put(`/drivers/${this.id}`, this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.loader = true;
            setTimeout(() => {
              this.$router.push("/drivers-manager");
            }, 1500);
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      } else {
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post("/drivers", this.data)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
            setTimeout(() => {
              this.$router.push("/drivers-manager");
            }, 1500);
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.loader = false;
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    uploadImage(event) {
      this.$store.dispatch("setLoader", true);
      const fd = new FormData();
      fd.append("image", event.target.files[0], event.target.files[0].name);
      // console.log(event.target.files[0]);
      this.$http
        .post("/upload", fd)
        .then((r) => {
          this.data.driver_photo = r.data.cover;
          this.$store.dispatch("setLoader", false);
        })
        .catch((e) => {
          alert(
            "Erro ao realizar upload da imagem tente novamente! " + e.message
          );
          this.$store.dispatch("setLoader", false);
          event.target.files = [];
        });
    },
    getCep(cep) {
      if (cep.length == 10) {
        this.loading = true;
        cep = cep.replace("-", "");
        cep = cep.replace(".", "");
        this.$http
          .get("https://viacep.com.br/ws/" + cep + "/json/")
          .then((response) => {
            this.data.driver_street = response.data.logradouro;
            this.data.driver_district = response.data.bairro;
            this.data.driver_city = response.data.localidade;
            this.data.driver_state = response.data.uf;
            this.loading = false;
          })
          .catch((e) => {
            this.message.snacshow = true;
            this.message.type = "warning";
            this.message.text = "Atencão cep não encontrado!" + e;
            this.loading = false;
          });
      }
    },
  },
};
</script>

<style>
.title {
  text-transform: uppercase;
  font-weight: 400;
}

.flexd {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.flexd p {
  margin: 10px 0;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
